import { useStyletron } from "baseui";
import { Label4, Paragraph4 } from "baseui/typography";
import React from "react";
import { OrderPopupContainer } from "./styled-components";

function OrderPopup({ type, order }) {
  return (
    <>
      <OrderPopupContainer>
        {type === "pickup" ? (
          <PickupInfo order={order} />
        ) : type === "dropoff" ? (
          <DropoffInfo order={order} />
        ) : null}
      </OrderPopupContainer>
    </>
  );
}

export function PickupInfo({ order }) {
  const [css] = useStyletron();
  return (
    <section
      className={css({
        padding: "8px",
      })}
    >
      <section>
        <Label4
          className={css({
            fontWeight: "bolder",
            fontSize: "18px",
          })}
        >
          {order.order_origins[0]?.location_name}
        </Label4>
        <br />
        <Label4
          className={css({
            fontSize: "18px",
          })}
        >
          Contact Info
        </Label4>
        <Paragraph4
          className={css({
            fontSize: "16px",
          })}
        >
          Name: {order.order_origins[0]?.contact_name}
        </Paragraph4>
        <Paragraph4
          className={css({
            fontSize: "16px",
          })}
        >
          Phone: {order.order_origins[0]?.contact_phone}
        </Paragraph4>
      </section>
    </section>
  );
}

export function DropoffInfo({ order }) {
  const [css] = useStyletron();

  return (
    <section
      className={css({
        padding: "8px",
      })}
    >
      <section>
        <Label4
          className={css({
            fontWeight: "bolder",
            fontSize: "18px",
          })}
        >
          {order.order_destinations[0]?.location_name}
        </Label4>
        <br />
        <Label4
          className={css({
            fontSize: "18px",
          })}
        >
          Contact Info
        </Label4>
        <Paragraph4
          className={css({
            fontSize: "16px",
          })}
        >
          Name: {order.order_destinations[0]?.contact_name}
        </Paragraph4>
        <Paragraph4
          className={css({
            fontSize: "16px",
          })}
        >
          Phone: {order.order_destinations[0]?.contact_phone}
        </Paragraph4>
      </section>
    </section>
  );
}

export default OrderPopup;
